module.exports = __webpack_public_path__ + "static/card-profile4-square-1a1649171cdecd24e7a16ea1340077df.jpg";